<ng-container *ngIf="errorMessage !== ''">
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<div class="container" *ngIf="errorMessage === ''">
    <div class="header">
        <div class="header-content">
            <span class="font20">PERFIL DE USUARIO</span>
        </div>
    </div>
    <div class="body">
        <div class="body-content">
            <div class="column1">
                <div class="cont">
                    <span class="label">Nombre Completo: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="maxInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{userData.user_fullname}}" #nameInput>
                    </mat-form-field>
                </div>

                <div class="cont">
                    <span class="label">Correo Electrónico: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="maxInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{userData.user_mail}}" #emailInput>
                    </mat-form-field>
                </div>

                <div class="cont">
                    <span class="label">Cliente: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="maxInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{userClient}}" #clientInput>
                    </mat-form-field>
                </div>
            </div>

            <div class="column2">
                <div class="cont">
                    <span class="label">Fecha Alta: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="maxInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{formatDateTime(userData.created_at)}}" #createdInput>
                    </mat-form-field>
                </div>

                <div class="cont">
                    <span class="label">Última modificación: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="maxInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{formatDateTime(this.userData.updated_at)}}" #updatedInput>
                    </mat-form-field>
                </div>

                <div class="cont">
                    <span class="label">Tipo de Usuario: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="maxInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{tipoUsuario}}" #tipoInput>
                    </mat-form-field>
                </div>

                <div class="cont">
                    <span class="label">Estado: </span>
                    <mat-form-field appearance="outline" [style.min-width.px]="statusInputWidth">
                        <input matInput type="text" [readonly]="true" value="{{userStatus}}" #statusInput>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>